import { centerInStrip, findAll } from './dom';

// Kategorije su na stranicama kataloga (telefon i tablet) pločice u traci koja se prevlači: na stranici kategorije traka se
// pomeri tako da je izabrana pločica na sredini, da kupac odmah vidi gde je (stranica se pri tom ne pomera). Bez skripte
// traka počinje od prve kategorije.
export function enhanceCategoryTiles(): void {
  findAll(document, 'category-tiles', HTMLElement).forEach(list => {
    const chosen = list.querySelector('[aria-current="page"]');
    if (chosen instanceof HTMLElement) centerInStrip(list, chosen);
  });
}
